import { ThemeColorVariable } from '@caspeco/casper-ui-library.base-ui.theme';
import { Icons } from '@caspeco/casper-ui-library.components.icon';
export const getAlertTextColor = (type) => {
    switch (type) {
        case 'info':
            return ThemeColorVariable.OnInfoContainer;
        case 'error':
            return ThemeColorVariable.OnErrorContainer;
        case 'warning':
            return ThemeColorVariable.OnWarningContainer;
        case 'neutral':
            return ThemeColorVariable.OnNeutralContainer;
        case 'success':
        default:
            return ThemeColorVariable.OnSuccessContainer;
    }
};
export const getAlertBackgroundColor = (type) => {
    switch (type) {
        case 'info':
            return ThemeColorVariable.InfoContainer;
        case 'error':
            return ThemeColorVariable.ErrorContainer;
        case 'warning':
            return ThemeColorVariable.WarningContainer;
        case 'neutral':
            return ThemeColorVariable.NeutralContainer;
        case 'success':
        default:
            return ThemeColorVariable.SuccessContainer;
    }
};
export const getAlertIcon = (type) => {
    switch (type) {
        case 'warning':
            return Icons.TriangleWarning;
        case 'success':
            return Icons.CircleSuccess;
        case 'error':
            return Icons.HexagonError;
        default:
            return Icons.CircleInfo;
    }
};
//# sourceMappingURL=alert.helper.js.map